import React, {
  useState,
  useEffect,
} from "react";
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  TableContainer,
  Button,
  Grid,
  TablePagination,
  CircularProgress,
  FormControlLabel,
  Checkbox,
  TextField,
} from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Breadcrumb from "src/layouts/full/shared/breadcrumb/Breadcrumb";
import PageContainer from "src/components/container/PageContainer";
import ParentCard from "src/components/shared/ParentCard";
import * as XLSX from "xlsx";
import {
  IconFileDownload,
  IconSearch,
} from "@tabler/icons";
import CustomFormLabel from "src/components/forms/theme-elements/CustomFormLabel";
import "./style.css";
import ReportService from "src/service/reports";
import moment from "moment";
import VehicleDetailsService from "src/service/vehicleDetails";
import DateTimeNew from "src/components/dateTime/DateTimeNew";
import { writeFile } from "xlsx";

import jsPDF from "jspdf";
import "jspdf-autotable";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CustomTextField from "src/components/forms/theme-elements/CustomTextField";
// import { head } from "lodash";

const BCrumb = [
  {
    to: "/",
    title: "Home",
  },
  {
    title: "Event Log",
  },
];

const EventLog = () => {
  const [eventLogs, setEventLogs] = useState([]);
  const [vehicle_list, setvehicleList] = useState(
    []
  );
  const [selectedVehicle, setSelectedVehicle] =
    useState([]);
  const [loading, setLoading] = useState(false);

  const [from_date, setFrom] = useState(
    new Date().setHours(new Date().getHours() - 1)
  );
  const [to_date, setTo] = useState(new Date());
  const [filters, setFilters] = useState({
    speedLimit: 0,
    stopTime: 0,
    timeInterval: 0,
    ignition: false,
    geofence: false,
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] =
    useState(10);

  const sessionData = JSON.parse(
    localStorage.getItem("user")
  );
  const [export_data, setExportData] = useState(
    []
  );

  const fetchVehicleNoData = async () => {
    try {
      const res =
        await VehicleDetailsService.fetch_distict_vehicle(
          {
            vehicle_type:
              sessionData?.data?.vehicle_type ||
              "",
            district_id:
              sessionData?.data?.district_id ||
              "",
            user_type:
              sessionData?.data?.user_type || "",
            user_id: sessionData?.data?.id || "",
          }
        );

      setvehicleList(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  const fetch_vehiclePerformance_report =
    async () => {
      setLoading(true); // Start loading
      try {
        // Construct the request payload conditionally
        const payload = {
          fromDate: moment(from_date).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          toDate: moment(to_date).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          vehicleNo: selectedVehicle,
          speedLimit: filters.speedLimit,
          stopTime: filters.stopTime,
          timeInterval: filters.timeInterval,
          ignition: filters.ignition,
          geofence: filters.geofence,
        };

        const res = await ReportService.eventLog(
          payload
        );
        console.log("Event Log===", res.data);
        res.data.length &&
          setRowsPerPage(res.data.length);
        setEventLogs(res.data);
        setExportData(res.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

  useEffect(() => {
    fetchVehicleNoData();
    // fetch_vehiclePerformance_report();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const exportVisibleDataToExcel = () => {
    const headers1 = [
      {
        v: "Event Log",
        t: "s",
        s: {
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        },
      },
    ];
    const headers2 = [
      {
        v: `Vehicle No -- ${selectedVehicle}`,
        t: "s",
        s: {
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        },
      },
    ];
    const headers3 = [
      {
        v: `Date :- ${moment(from_date).format(
          "DD-MM-YYYY HH:mm a"
        )} - ${moment(to_date).format(
          "DD-MM-YYYY HH:mm a"
        )}`,
        t: "s",
        s: {
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        },
      },
    ];

    const headers = [
      "#",
      "Event",
      "Date Time",
      "Duration",
      "KMS",
      "Latitude",
      "Longitude",
      "Place Name"
    ];

    const data = export_data.map((man, index) => [
      index + 1,
      man?.event,
      man?.dateTime,
      man?.duration,
      man?.kms,
      man?.coordinates?.lat,
      man?.coordinates?.lng,
      man?.placeName,
    ]);

    const exportData = [
      headers1,
      headers2,
      headers3,
      headers,
      ...data,
    ];

    const ws =
      XLSX.utils.aoa_to_sheet(exportData);

    // Define merges
    ws["!merges"] = [
      { s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }, // Merges cells A1:E1 (for Event Log)
      { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } }, // Merges cells A2:E2 (for Vehicle No)
      { s: { r: 2, c: 0 }, e: { r: 2, c: 4 } }, // Merges cells A3:E3 (for Date range)
    ];

    // Adjust column widths (optional)
    ws["!cols"] = [
      { wch: 10 },
      { wch: 20 },
      { wch: 30 },
      { wch: 15 },
      { wch: 10 },
    ];

    // Center-align the merged cells (explicitly setting cell alignment)
    ws["A1"].s = {
      alignment: {
        horizontal: "center",
        vertical: "center",
      },
    };
    ws["A2"].s = {
      alignment: {
        horizontal: "center",
        vertical: "center",
      },
    };
    ws["A3"].s = {
      alignment: {
        horizontal: "center",
        vertical: "center",
      },
    };

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(
      wb,
      ws,
      "Sheet 1"
    );

    const fileName = "Event Log.xlsx";

    writeFile(wb, fileName);
  };

  const paginatedData = eventLogs.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(
      parseInt(event.target.value, 10)
    );
    setPage(0);
  };

  const exportVisibleDataToPDF = () => {
    const doc = new jsPDF("potrait"); // Set the orientation to landscape

    const title = "Event Log";
    // Set the font size and type for the title
    doc.setFontSize(22);
    doc.setFont("helvetica", "bold");
    // Get the page width
    const pageWidth =
      doc.internal.pageSize.getWidth();

    // Calculate the text width and position it in the center
    const textWidth = doc.getTextWidth(title);
    const xPosition = (pageWidth - textWidth) / 2;

    // Add the title text to the PDF, centered horizontally
    doc.text(title, xPosition, 20);

    doc.setFontSize(10);
    doc.setFont("helvetica");
    doc.text(
      `Vehicle No: ${selectedVehicle}`,
      10,
      25
    );
    doc.text(
      `Date : ${moment(from_date).format(
        "DD-MM-YYYY HH:mm:ss"
      )} - ${moment(to_date).format(
        "DD-MM-YYYY HH:mm:ss"
      )}`,
      10,
      30
    );
    filters.speedLimit &&
      doc.text(
        `Speed Limit: ${filters.speedLimit}`,
        10,
        35
      );
    filters.stopTime &&
      doc.text(
        `Stop Time: ${filters.stopTime}`,
        10,
        40
      );
    filters.timeInterval &&
      doc.text(
        `Time Interval: ${filters.timeInterval}`,
        10,
        45
      );
    filters.ignition &&
      doc.text(
        `Ignition: ${filters.ignition}`,
        10,
        50
      );
    filters.geofence &&
      doc.text(
        `Geofence: ${filters.geofence}`,
        10,
        55
      );

    // Adjust the Y-coordinate before adding more content to avoid overlap
    const titleYPosition = 50; // Y-coordinate of the title
    const spacing = 20; // Adjust this value for more or less space
    const nextContentYPosition =
      titleYPosition + spacing;

    const headers = [
      "#",
      "Event",
      "Date Time",
      "Duration",
      "KMS",
      "Latitude",
      "Longitude",
      "Place Name"
    ];

    const data = eventLogs.map((item, index) => [
      index + 1 + page * rowsPerPage,
      item?.event,
      item?.dateTime,
      item?.duration,
      item?.kms,
      item?.coordinates?.lat,
      item?.coordinates?.lng,
      item?.placeName,
    ]);

    doc.autoTable({
      head: [headers],
      body: data,
      startY: 60,
      startX: 20,
      margin: { horizontal: 10 },
      headStyles: { fillColor: [44, 62, 80] },
      styles: {
        cellPadding: 2,
        fontSize: 8,
        textColor: [0, 0, 0],
      },
      headStyles: {
        fillColor: [44, 62, 80],
        textColor: [255, 255, 255],
      },
    });
    doc.save("Event Log.pdf");
  };

  return (
    <PageContainer
      title="Event Log"
      description="this is Basic Table page"
    >
      <Breadcrumb
        title="Event Log"
        items={BCrumb}
      />

      <ParentCard title="">
        <Grid
          container
          alignItems="center"
          style={{ marginTop: "10px" }}
        >
          <Grid
            item
            container
            xs={12}
            style={{ paddingBottom: "20px" }}
            alignItems="center"
            spacing={2}
          >
            <Grid
              item
              lg={3}
              md={4}
              sm={6}
              xs={12}
            >
              <CustomFormLabel htmlFor="from_date">
                From Date{" "}
                <span style={{ color: "red" }}>
                  *
                </span>
              </CustomFormLabel>
              <DateTimeNew
                value={from_date}
                setValue={(newValue) => {
                  setFrom(newValue);
                }}
              />
            </Grid>
            <Grid
              item
              lg={3}
              md={4}
              sm={6}
              xs={12}
            >
              <CustomFormLabel htmlFor="to_date">
                To Date{" "}
                <span style={{ color: "red" }}>
                  *
                </span>
              </CustomFormLabel>
              <DateTimeNew
                value={to_date}
                setValue={(newValue) =>
                  setTo(newValue)
                }
              />
            </Grid>

            <Grid
              item
              lg={2}
              md={4}
              sm={6}
              xs={12}
            >
              <CustomFormLabel>
                Vehicle No{" "}
                <span style={{ color: "red" }}>
                  *
                </span>
              </CustomFormLabel>
              <Autocomplete
                id="vehicle_no"
                name="vehicle_no"
                options={vehicle_list}
                getOptionLabel={(option) =>
                  option.vehicle_no
                }
                value={
                  vehicle_list.find(
                    (option) =>
                      option.vehicle_no ===
                      selectedVehicle
                  ) || null
                }
                onChange={(event, newValue) =>
                  setSelectedVehicle(
                    newValue
                      ? newValue.vehicle_no
                      : ""
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    placeholder="Select Vehicle No"
                    fullWidth
                  />
                )}
              />
            </Grid>

            <Grid
              item
              lg={2}
              md={2}
              sm={4}
              xs={6}
              style={{ marginTop: "30px" }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    icon={
                      <CheckBoxOutlineBlankIcon />
                    }
                    checkedIcon={<CheckBoxIcon />}
                    id="ignition"
                    name="ignition"
                    value={filters.ignition}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        ignition:
                          e.target.checked,
                      })
                    }
                  />
                }
                label="Ignition"
              />
            </Grid>
            <Grid
              item
              lg={2}
              md={2}
              sm={4}
              xs={6}
              style={{ marginTop: "30px" }}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    color="primary"
                    icon={
                      <CheckBoxOutlineBlankIcon />
                    }
                    checkedIcon={<CheckBoxIcon />}
                    id="geofence"
                    name="geofence"
                    value={filters.geofence}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        geofence:
                          e.target.checked,
                      })
                    }
                  />
                }
                label="Geofence"
              />
            </Grid>
          </Grid>
          <Grid
            item
            container
            xs={12}
            style={{ paddingBottom: "20px" }}
            alignItems="center"
            spacing={2}
          >
            <Grid
              item
              lg={3}
              md={4}
              sm={6}
              xs={12}
            >
              <CustomFormLabel htmlFor="from_date">
                Speed Limit
              </CustomFormLabel>
              <CustomTextField
                id="speedLimit"
                name="speedLimit"
                type="number"
                value={filters.speedLimit}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    speedLimit: e.target.value,
                  })
                }
                style={{ width: "100%" }}
              />
            </Grid>
            <Grid
              item
              lg={3}
              md={4}
              sm={6}
              xs={12}
            >
              <CustomFormLabel htmlFor="to_date">
                Stop Time
              </CustomFormLabel>
              <CustomTextField
                id="stopTime"
                name="stopTime"
                type="number"
                value={filters.stopTime}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    stopTime: e.target.value,
                  })
                }
                style={{ width: "100%" }}
              />
            </Grid>

            <Grid
              item
              lg={3}
              md={4}
              sm={6}
              xs={12}
            >
              <CustomFormLabel>
                Time Interval
              </CustomFormLabel>
              <CustomTextField
                id="timeInterval"
                name="timeInterval"
                type="number"
                value={filters.timeInterval}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    timeInterval: e.target.value,
                  })
                }
                style={{ width: "100%" }}
              />
            </Grid>

            <Grid
              item
              lg={1}
              md={2}
              sm={4}
              xs={6}
              style={{ marginTop: "30px" }}
            >
              <Button
                onClick={
                  fetch_vehiclePerformance_report
                }
                style={{ padding: "10px" }}
              >
                <IconSearch />
              </Button>
            </Grid>
            <Grid
              item
              lg={1}
              md={2}
              sm={4}
              xs={6}
              style={{ marginTop: "30px" }}
            >
              <Button
                variant="contained"
                color="success"
                onClick={exportVisibleDataToExcel}
                style={{ padding: "10px" }}
              >
                <IconFileDownload width={20} />
              </Button>
            </Grid>
            <Grid
              item
              lg={1}
              md={2}
              sm={4}
              xs={6}
              style={{ marginTop: "30px" }}
            >
              <Button
                variant="contained"
                color="primary"
                onClick={exportVisibleDataToPDF}
                style={{ padding: "10px" }}
              >
                <PictureAsPdfIcon />
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Paper variant="outlined">
          <TableContainer>
            <Table
              id="allotment_report_table"
              aria-label="simple table"
              sx={{
                whiteSpace: "",
              }}
            >
              <TableHead
                style={{
                  backgroundColor: "silver",
                }}
              >
                <TableRow>
                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      #
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      Event
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      Date Time
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      Duration
                    </Typography>
                  </TableCell>

                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      KMS
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      Latitude
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      Longitude
                    </Typography>
                  </TableCell>
                  <TableCell>
                    <Typography
                      style={{
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                      variant="h6"
                    >
                      Place Name
                    </Typography>
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell
                      colSpan={8}
                      style={{
                        textAlign: "center",
                      }}
                    >
                      <CircularProgress />
                    </TableCell>
                  </TableRow>
                ) : paginatedData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={8}>
                      <Typography
                        style={{
                          fontSize: "14px",
                          textAlign: "center",
                          color: "red",
                        }}
                        variant="h6"
                      >
                        No records found
                      </Typography>
                    </TableCell>
                  </TableRow>
                ) : (
                  paginatedData.map(
                    (logs, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {index + 1}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {logs?.event}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {logs?.dateTime}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {logs?.duration}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {logs?.kms}
                          </Typography>
                        </TableCell>

                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {logs?.coordinates?.lat}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {logs?.coordinates?.lng}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <Typography
                            style={{
                              fontSize: "14px",
                              textAlign: "center",
                            }}
                            variant="h6"
                          >
                            {logs?.placeName}
                          </Typography>
                        </TableCell>



                      </TableRow>
                    )
                  )
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[
              10, 25, 50, 100, 250, 500, 5000,
              10000,
            ]}
            component="div"
            count={eventLogs.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={
              handleChangeRowsPerPage
            }
          />
        </Paper>
      </ParentCard>
    </PageContainer>
  );
};

export default EventLog;
